// extracted by mini-css-extract-plugin
export default {"task":"Task_task__uT4mh","task-desc":"Task_task-desc__dO5rN","check-box":"Task_check-box__N4dXE"};